// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 height=%2724px%27 viewBox=%270 -960 960 960%27 width=%2724px%27 fill=%27%23bf9b30%27%3E%3Cpath d=%27M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 height=%2724px%27 viewBox=%270 -960 960 960%27 width=%2724px%27 fill=%27%23cd1919%27%3E%3Cpath d=%27m336-280-56-56 144-144-144-143 56-56 144 144 143-144 56 56-144 143 144 144-56 56-143-144-144 144Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.react-calendar {
    font-family: var(--main-font);
    background: inherit;
    color: inherit;
    border: none;
}

.react-calendar__navigation button {
    color: inherit;
    font-size: 1.1rem;
    min-width: 25px;
    padding-inline-start: 0;
    padding-inline-end: 0;
}

.react-calendar__navigation button:disabled {
    background-color: transparent;
    color: inherit;
}

.react-calendar__tile:disabled {
    background-color: var(--unavailable-calendar-color);
}

.react-calendar__tile--now {
    background: inherit;
}

.react-calendar__tile:enabled:hover, .react-calendar__tile:enabled:focus {
    background: inherit;
}

.react-calendar__tile--active, .react-calendar__tile:enabled.react-calendar__tile--active {
    background: var(--selected-puzzle-color);
    border-radius: 50%;
}

.react-calendar__tile:not(.react-calendar__month-view__days__day--neighboringMonth, .react-calendar__decade-view__years__year--neighboringDecade, .react-calendar__century-view__decades__decade--neighboringCentury, :disabled){
    color: var(--default-text-color);
}

 
abbr[title] {
    text-decoration: none;
}
.react-calendar__navigation {
    margin: 0.5rem 0;
    gap: 0.4rem;
}

.react-calendar__month-view__weekdays__weekday {
    padding: 0;
}

button.react-calendar__navigation__label {
    font-family: var(--main-font);
}

.react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus {
    background-color: transparent;
}

.date-selector-modal-container h2 {
    font-size: 1.5rem;
    margin-bottom: 0;
    text-align: center;
    font-weight: 600;
}

.react-calendar__month-view__days__day.react-calendar__tile.unseen-tile {
    position: relative;
}

.react-calendar__month-view__days__day.react-calendar__tile.unseen-tile::after {
    background-color: var(--unseen-blue);
    width: 7px;
    aspect-ratio: 1.0;
    content: "";
    position: absolute;
    display: block;
    right: 11.5%;
    top: 14%;
    border-radius: 6px;
}


.react-calendar__month-view__days__day.react-calendar__tile.in-progress-tile {
    position: relative;
}

.react-calendar__month-view__days__day.react-calendar__tile.in-progress-tile::after {
    border: var(--unseen-blue);
    width: 7px;
    aspect-ratio: 1.0;
    content: "";
    position: absolute;
    display: block;
    right: 11.5%;
    top: 14%;
    border-radius: 6px;
}


.react-calendar__month-view__days__day.react-calendar__tile.solved-tile {
    position: relative;
}
.react-calendar__month-view__days__day.react-calendar__tile.solved-tile:not(.react-calendar__tile--active, .react-calendar__tile:enabled.react-calendar__tile--active)::after {
position: absolute;
  content: '';
  display: inline-block;
  width: 20px;
  height: 20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});


  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  top: 0%;
  right: -7%;
}

.react-calendar__month-view__days__day.react-calendar__tile.failed-tile {
    position: relative;
}

.react-calendar__month-view__days__day.react-calendar__tile.failed-tile:not(.react-calendar__tile--active, .react-calendar__tile:enabled.react-calendar__tile--active)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    position: absolute;

  content: '';
  display: inline-block;
  width: 20px;
  height: 20px;


  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  top: 0%;
  right: -7%;

}`, "",{"version":3,"sources":["webpack://./src/DateSelector.css"],"names":[],"mappings":";AACA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;;AAGA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,QAAQ;IACR,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,QAAQ;IACR,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;AACtB;AACA;AACA,kBAAkB;EAChB,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;IACV,yDAA4O;;;EAG9O,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,OAAO;EACP,UAAU;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yDAAwR;IACxR,kBAAkB;;EAEpB,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;;;EAGZ,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,OAAO;EACP,UAAU;;AAEZ","sourcesContent":["\n.react-calendar {\n    font-family: var(--main-font);\n    background: inherit;\n    color: inherit;\n    border: none;\n}\n\n.react-calendar__navigation button {\n    color: inherit;\n    font-size: 1.1rem;\n    min-width: 25px;\n    padding-inline-start: 0;\n    padding-inline-end: 0;\n}\n\n.react-calendar__navigation button:disabled {\n    background-color: transparent;\n    color: inherit;\n}\n\n.react-calendar__tile:disabled {\n    background-color: var(--unavailable-calendar-color);\n}\n\n.react-calendar__tile--now {\n    background: inherit;\n}\n\n.react-calendar__tile:enabled:hover, .react-calendar__tile:enabled:focus {\n    background: inherit;\n}\n\n.react-calendar__tile--active, .react-calendar__tile:enabled.react-calendar__tile--active {\n    background: var(--selected-puzzle-color);\n    border-radius: 50%;\n}\n\n.react-calendar__tile:not(.react-calendar__month-view__days__day--neighboringMonth, .react-calendar__decade-view__years__year--neighboringDecade, .react-calendar__century-view__decades__decade--neighboringCentury, :disabled){\n    color: var(--default-text-color);\n}\n\n \nabbr[title] {\n    text-decoration: none;\n}\n.react-calendar__navigation {\n    margin: 0.5rem 0;\n    gap: 0.4rem;\n}\n\n.react-calendar__month-view__weekdays__weekday {\n    padding: 0;\n}\n\nbutton.react-calendar__navigation__label {\n    font-family: var(--main-font);\n}\n\n.react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus {\n    background-color: transparent;\n}\n\n.date-selector-modal-container h2 {\n    font-size: 1.5rem;\n    margin-bottom: 0;\n    text-align: center;\n    font-weight: 600;\n}\n\n.react-calendar__month-view__days__day.react-calendar__tile.unseen-tile {\n    position: relative;\n}\n\n.react-calendar__month-view__days__day.react-calendar__tile.unseen-tile::after {\n    background-color: var(--unseen-blue);\n    width: 7px;\n    aspect-ratio: 1.0;\n    content: \"\";\n    position: absolute;\n    display: block;\n    right: 11.5%;\n    top: 14%;\n    border-radius: 6px;\n}\n\n\n.react-calendar__month-view__days__day.react-calendar__tile.in-progress-tile {\n    position: relative;\n}\n\n.react-calendar__month-view__days__day.react-calendar__tile.in-progress-tile::after {\n    border: var(--unseen-blue);\n    width: 7px;\n    aspect-ratio: 1.0;\n    content: \"\";\n    position: absolute;\n    display: block;\n    right: 11.5%;\n    top: 14%;\n    border-radius: 6px;\n}\n\n\n.react-calendar__month-view__days__day.react-calendar__tile.solved-tile {\n    position: relative;\n}\n.react-calendar__month-view__days__day.react-calendar__tile.solved-tile:not(.react-calendar__tile--active, .react-calendar__tile:enabled.react-calendar__tile--active)::after {\nposition: absolute;\n  content: '';\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='%23bf9b30'%3E%3Cpath d='M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z'/%3E%3C/svg%3E\");\n\n\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  top: 0%;\n  right: -7%;\n}\n\n.react-calendar__month-view__days__day.react-calendar__tile.failed-tile {\n    position: relative;\n}\n\n.react-calendar__month-view__days__day.react-calendar__tile.failed-tile:not(.react-calendar__tile--active, .react-calendar__tile:enabled.react-calendar__tile--active)::after {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='%23cd1919'%3E%3Cpath d='m336-280-56-56 144-144-144-143 56-56 144 144 143-144 56 56-144 143 144 144-56 56-143-144-144 144Z'/%3E%3C/svg%3E\");\n    position: absolute;\n\n  content: '';\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n\n\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center;\n  top: 0%;\n  right: -7%;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
